var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"h4 mb-4 text-gray-700"},[_vm._v(" "+_vm._s(_vm.$t('terms.titleLegalBasesContestAcepted'))+" ")]),_c('div',{staticClass:"h6 mb-4 text-gray-600"},[_vm._v(" "+_vm._s(_vm.$t('terms.subtitleLegalBasesContestAcepted'))+" ")]),_c('termsAccepted',{attrs:{"accepted-terms":_vm.acceptedTerms}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }